var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"selenium":"footer"}},[_c('client-only',[(!_vm.isPro)?_c('app-footer-upper'):_vm._e()],1),_c('app-footer-lower')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }